import React, { useState } from 'react'
import { ROUTE } from '../../route/Route'
import { useTranslation } from "react-i18next";
import { Link, useLocation, useHistory } from "react-router-dom";
import { alreadyInCart } from '../../constant/utils';
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';


const BookButton = (props: any) => {
    const { t } = useTranslation();
    const { type, data } = props; 
    const history = useHistory();
    const [hvr, setHvr] = useState<any>(false);
    const bookingData: any = useSelector((state: any) => (state.checkout.bookingData ? state.checkout.bookingData : {}));
    const handleCheckout = (e: any) => {
        e.preventDefault();
        const already = alreadyInCart(type, (type == "test" ? data?.TestCode : data?.PackageCode));
        if(!already){
            if(data?.SellingPrice === 0) {
                toast.error("Home collection is not available for this, please change your location");
            } else if(bookingData?.selectedMember?.gender && data?.Gender && data?.Gender != "both" && bookingData?.selectedMember?.gender?.toUpperCase() !== data?.Gender?.toUpperCase()) {
                    toast.error(`You can not add this test, this test only for ${data?.Gender}`);
            } else if(data?.SellingPrice!==0){
                history.push(ROUTE.CHECKOUT, { type: type, data: data }); 
            }
        }
    }
    return (
        <a href={"#"} onClick={(e: any) => handleCheckout(e)} className="button--hexagon booknow" style={{margin:'0px 0px'}} onMouseLeave={(e: any) => setHvr(false)} onMouseEnter={(e: any) => setHvr(true)}>
            <span> <img src={!hvr ? "/assets/img/calendar.png" : "/assets/img/calendar2.png"} className="scale_booknow" />{t("book_now")}<i className="fa fa-long-arrow-right" aria-hidden="true"></i></span>
        </a>
    ) 
}

export default BookButton
